import { render, staticRenderFns } from "./PredictiveTyper.vue?vue&type=template&id=4503be0a&scoped=true&"
import script from "./PredictiveTyper.vue?vue&type=script&lang=js&"
export * from "./PredictiveTyper.vue?vue&type=script&lang=js&"
import style0 from "./PredictiveTyper.vue?vue&type=style&index=0&id=4503be0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503be0a",
  null
  
)

export default component.exports